/**
     * JourneyUpdated.contract.ts — Event Contract System™ (generation v1).
     * The operator's journey state advanced after a base change (observability — the Journey screen is legacy until the v2 Mission Engine sprint).
     */

    import type { EventContract } from '../EventContractRegistry';

    export const JourneyUpdatedContract: EventContract = {
      name: 'JourneyUpdated',
      version: 1,
      description: "The operator's journey state advanced after a base change (observability — the Journey screen is legacy until the v2 Mission Engine sprint).",
      publishers: ["core"],
      subscribers: ["dev-center:live-feed"],
      fields: [
        { name: 'locationId', type: 'string', required: true, description: "The base the journey advanced to" },
      ],
      allowExtraFields: false,
      timestampPolicy: "Workflow time (now) inside runLocationChangedWorkflow.",
      stability: 'observability',
      deprecated: false,
      example: {"locationId":"lisbon"},
    };
    